import React from 'react';
import { MdOutlineCancel } from "react-icons/md";

const PackerOfferActions = props => {
  const showCancel = props.item.status !== 'cancelled';

  return (
    <td key={props.item.id}>
      <button onClick={() => props.edit(props.item.id, props.item.props_index)} className="btn btn-sm btn-info">
        <i className="flaticon-edit-1" />
      </button>
      &nbsp;
      {showCancel ? (
        <button
          onClick={() => {
            props.cancel(props.item.id);
          }}
          className="btn btn-sm btn-danger"
        >
          <MdOutlineCancel />
        </button>
      ) : (
        false
      )}
    </td>
  );
};

export default PackerOfferActions;
